import ApiClient from './ApiClient';

const API_CLIENT_ID = window.API_CLIENT_ID;
const API_CLIENT_SECRET = window.API_CLIENT_SECRET;

export default class ApiAuth {
    static login = (data) => {
        return ApiClient.get({
            query: {
                ...data,
                client_id: API_CLIENT_ID,
                client_secret: API_CLIENT_SECRET,
                grant_type: 'password',
            },
            url: '/oauth/v2/token',
        })
            .then((responseData) => {
                ApiAuth.saveAuth(responseData);
                return responseData;
            });
    }

    static loginFromToken = (authData) => {
        return ApiClient.get({
            headers: {
                Authorization: ApiAuth.ucfirstTokenType(authData.token_type) + ' ' + authData.access_token,
            },
            url: '/api/me',
        })
            .then(() => {
                ApiAuth.saveAuth(authData);
                return authData;
            })
            .catch((error) => {
                return ApiAuth.tokenRefresher(error)
                    .then((refreshedAuth) => ApiAuth.loginFromToken(refreshedAuth));
            });
    }

    static tokenRefresher = (error) => {
        if (
            error.status === 401 &&
            error.response &&
            error.response.body &&
            error.response.body.error === 'invalid_grant'
        ) {
            return ApiClient.post({
                body: {
                    client_id: API_CLIENT_ID,
                    client_secret: API_CLIENT_SECRET,
                    grant_type: 'refresh_token',
                    refresh_token: ApiAuth.getAuth().refresh_token,
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                url: '/oauth/v2/token',
            });
        }

        return Promise.reject(error);
    }

    static isLogged = () => {
        const auth = JSON.parse(localStorage.getItem('auth'));
        return !!(auth && auth.access_token);
    }

    static logout = () => {
        localStorage.removeItem('auth');
    }

    static getAuth = () => {
        return JSON.parse(localStorage.getItem('auth'));
    }

    static saveAuth = (authData) => {
        const fixedAuthData = {
            ...authData,
            token_type: ApiAuth.ucfirstTokenType(authData.token_type),
        };

        ApiClient.addDefaultHeaders({
            Authorization: fixedAuthData.token_type + ' ' + fixedAuthData.access_token,
        });
        ApiClient.setErrorInterceptor(ApiAuth.tokenRefresher);
        localStorage.setItem('auth', JSON.stringify(fixedAuthData));
    }

    static ucfirstTokenType(tokenType) {
        return tokenType.charAt(0).toUpperCase() + tokenType.slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiAuth.js